import(/* webpackMode: "eager" */ "/app/src/app/services/outstaffing/page.tsx");
